import { render, staticRenderFns } from "./QuizAnswers.vue?vue&type=template&id=9552c630&scoped=true"
import script from "@/components/quiz-anwsers/QuizAnswers.ts?vue&type=script&lang=ts&external"
export * from "@/components/quiz-anwsers/QuizAnswers.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/quiz-anwsers/quiz-answers.scss?vue&type=style&index=0&id=9552c630&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9552c630",
  null
  
)

export default component.exports